module.exports = __webpack_public_path__ + "img/Play-time-compressor_tn.c221e94b.jpg";